module.exports = __webpack_public_path__ + "static/media/FJ.6a4e98b3.svg";